"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
let TokenGroup = class TokenGroup extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
TokenGroup.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-wrap: wrap;
      gap: var(--space-2);
    }
  `;
TokenGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-token-group')
], TokenGroup);
exports.TokenGroup = TokenGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW4tZ3JvdXAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0b2tlbi1ncm91cC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWlEO0FBRzFDLElBQU0sVUFBVSxHQUFoQixNQUFNLFVBQVcsU0FBUSxnQkFBVTtJQVN4QyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUFaTSxpQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7R0FNbEIsQ0FBQTtBQVBVLFVBQVU7SUFEdEIsSUFBQSw2QkFBYSxFQUFDLGdCQUFnQixDQUFDO0dBQ25CLFVBQVUsQ0FjdEI7QUFkWSxnQ0FBVSJ9